// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".width8[data-v-58fc766a] {\n  width: 100%;\n}\n.width9[data-v-58fc766a] {\n  width: 95%;\n}\n.tempImgList[data-v-58fc766a] {\n  width: 38px !important;\n  height: 30px !important;\n  cursor: pointer;\n  position: absolute;\n  z-index: 11;\n}\n.tempImgList img[data-v-58fc766a] {\n  width: 38px !important;\n  height: 30px !important;\n}", ""]);
// Exports
module.exports = exports;
